import { AbfragerStage_ } from '../AbfragerStage_';
import { AbfragerQuestionScene } from '../scenes/showQuestion/AbfragerQuestionScene';
export class PackageAbfragerRunComponents {
    AbfragerStage_ = AbfragerStage_;
    AbfragerQuestionScene = AbfragerQuestionScene;
}
